// SCRUM-491 / SCRUM-422: pick the target, preview the plan, confirm.
import React, { useState } from 'react';
import styles from '../ConfirmModal/ConfirmModal.module.css';
import { mergeSummary } from './mergeSummary';

// kind: 'athlete' | 'parent'. options: [{ id, label }] candidate targets.
export default function MergeModal({ kind, source, options, preview, merge, onDone, onCancel }) {
  const [targetId, setTargetId] = useState('');
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const run = async (fn) => {
    setBusy(true); setError('');
    try { return await fn(); } catch (e) { setError(e.message); return null; } finally { setBusy(false); }
  };
  const onPreview = async () => setPlan(await run(() => preview(source.id, targetId)));
  const onConfirm = async () => {
    const done = await run(() => merge(source.id, targetId));
    if (done !== null) onDone(done);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p className={styles.message}>Merge {kind === 'athlete' ? 'athlete' : 'account'} <strong>{source.label}</strong> into:</p>
        <select value={targetId} disabled={busy} onChange={(e) => { setTargetId(e.target.value); setPlan(null); }}>
          <option value="">Choose…</option>
          {options.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
        {plan && <ul>{mergeSummary(kind, plan).map((l) => <li key={l}>{l}</li>)}</ul>}
        {error && <p style={{ color: '#b91c1c' }}>{error}</p>}
        <div className={styles.actions}>
          <button className={styles.cancel} onClick={onCancel} disabled={busy}>Cancel</button>
          {!plan || plan.refused
            ? <button className={styles.confirm} onClick={onPreview} disabled={busy || !targetId}>Preview</button>
            : <button className={styles.confirm} onClick={onConfirm} disabled={busy}>Confirm merge</button>}
        </div>
      </div>
    </div>
  );
}
